import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

export default function TestCheckout() {
  const [amount, setAmount] = useState(100);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [method, setMethod] = useState('RAZORPAY');

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    setLoading(true);
    setMessage('');
    
    try {
      const res = await loadRazorpayScript();
      if (!res) {
        setMessage("Razorpay SDK failed to load. Are you online?");
        setLoading(false);
        return;
      }

      // Step 1: Create Order
      const createOrderRes = await fetch('http://localhost:5000/api/create-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: amount, // already in paise if we say minimum 100
          currency: 'INR',
          receipt: 'receipt_test_' + Date.now()
        })
      });

      if (!createOrderRes.ok) {
        const errorData = await createOrderRes.json();
        throw new Error(errorData.error || "Failed to create order");
      }

      const orderData = await createOrderRes.json();

      // Step 2: Open Razorpay Checkout Modal
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Enter the Key ID generated from the Dashboard
        amount: orderData.amount,
        currency: orderData.currency,
        name: "Smart Sangola",
        description: "Test Transaction",
        order_id: orderData.order_id,
        handler: async function (response) {
          // Step 3: Verify Signature
          setMessage("Verifying payment...");
          try {
            const verifyRes = await fetch('http://localhost:5000/api/verify-payment', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature
              })
            });

            const verifyData = await verifyRes.json();

            if (verifyData.success) {
              setMessage(`Payment successful! Payment ID: ${response.razorpay_payment_id}`);
            } else {
              setMessage(`Payment verification failed: ${verifyData.message}`);
            }
          } catch (err) {
            setMessage("Verification error: " + err.message);
          }
        },
        prefill: {
          name: "Test User",
          email: "test@example.com",
          contact: "9999999999"
        },
        notes: {
          address: "Smart Sangola Office"
        },
        theme: {
          color: "#3399cc"
        }
      };

      const paymentObject = new window.Razorpay(options);
      
      paymentObject.on('payment.failed', function (response){
        setMessage(`Payment failed: ${response.error.description}`);
      });

      paymentObject.open();

    } catch (err) {
      setMessage("Error: " + err.message);
    }
    
    setLoading(false);
  };

  return (
    <div className="page-container">
      <div className="card" style={{ maxWidth: '500px', margin: '0 auto', marginTop: '50px' }}>
        <div className="card-header">
          <div className="card-title">Razorpay Web Checkout</div>
          <div className="card-subtitle">Test frontend and backend integration</div>
        </div>
        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div className="input-group">
            <label className="input-label">Amount (in paise, min 100 paise = ₹1)</label>
            <input 
              type="number" 
              className="input" 
              value={amount} 
              onChange={(e) => setAmount(Number(e.target.value))} 
              min="100"
            />
          </div>

          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <button 
              className={`btn ${method === 'RAZORPAY' ? 'btn-primary' : ''}`}
              style={{ flex: 1, backgroundColor: method === 'RAZORPAY' ? '' : '#f1f5f9', color: method === 'RAZORPAY' ? '#fff' : '#333' }}
              onClick={() => setMethod('RAZORPAY')}
            >
              Razorpay
            </button>
            <button 
              className={`btn ${method === 'QR' ? 'btn-primary' : ''}`}
              style={{ flex: 1, backgroundColor: method === 'QR' ? '' : '#f1f5f9', color: method === 'QR' ? '#fff' : '#333' }}
              onClick={() => setMethod('QR')}
            >
              Direct UPI (QR)
            </button>
          </div>
          
          {method === 'RAZORPAY' ? (
            <button 
              className="btn btn-primary" 
              onClick={handlePayment} 
              disabled={loading}
              style={{ padding: '12px', justifyContent: 'center' }}
            >
              {loading ? 'Processing...' : 'Pay with Razorpay'}
            </button>
          ) : (
            <div style={{ textAlign: 'center', padding: '20px', border: '1px solid #e2e8f0', borderRadius: '8px', backgroundColor: '#f8fafc' }}>
              <p style={{ fontWeight: '600', marginBottom: '15px' }}>Scan to Pay ₹{(amount / 100).toFixed(2)}</p>
              <div style={{ display: 'inline-block', padding: '10px', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                <QRCodeCanvas 
                  value={`upi://pay?pa=9763406376@upi&pn=Smart Sangola&am=${amount/100}&cu=INR`} 
                  size={200} 
                />
              </div>
              <p style={{ marginTop: '15px', color: '#3b82f6', fontWeight: 'bold' }}>9763406376@upi</p>
              <button className="btn btn-primary" style={{ marginTop: '15px', width: '100%', justifyContent: 'center' }} onClick={() => setMessage("Payment marked as done!")}>
                I have paid
              </button>
            </div>
          )}

          {message && (
            <div style={{ 
              marginTop: '15px', 
              padding: '10px', 
              borderRadius: '8px', 
              backgroundColor: message.includes('failed') || message.includes('Error') ? '#ffebee' : '#e8f5e9',
              color: message.includes('failed') || message.includes('Error') ? '#c62828' : '#2e7d32',
              fontWeight: '500'
            }}>
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
